import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import dayjs from 'dayjs';
import { TextField, Box, Backdrop } from '@mui/material';
import styled from '@emotion/styled';

// Wrapper for controlling the overall layout of the input
const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 150px; /* Enforce max-width on the wrapper */
  width: 100%; /* Allow responsiveness */
`;

// Styled components
const StyledTextField = styled(TextField)`
  width: 100%;
  max-width: 150px;
  
  & .MuiInputBase-root {
    cursor: pointer; /* Indicate the field is clickable */
  }
`;

const CalendarBackdrop = styled(Backdrop)`
  z-index: 1300; /* Ensure it overlays everything */
`;

const CalendarContainer = styled(Box)`
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  max-width: 400px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
`;

const CustomDatePicker = ({ initialDate, onDateChange }) => {
  const [selectedDate, setSelectedDate] = useState(dayjs(initialDate || new Date()));
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    setIsCalendarOpen(false); // Close calendar after selection
    if (onDateChange) {
      onDateChange(newDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Wrapper>
        <StyledTextField
          value={selectedDate.format('DD/MM/YYYY')} // Display date in DD/MM/YYYY format
          onClick={() => setIsCalendarOpen(true)} // Open calendar on click
          InputProps={{
            readOnly: true, // Make the text field non-editable
          }}
        />
      </Wrapper>
      <CalendarBackdrop open={isCalendarOpen} onClick={() => setIsCalendarOpen(false)}>
        <CalendarContainer onClick={(e) => e.stopPropagation()}>
          <StaticDatePicker
            value={selectedDate}
            onChange={handleDateChange}
            displayStaticWrapperAs="desktop"
          />
        </CalendarContainer>
      </CalendarBackdrop>
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
